// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"86a999ff","591":"3dacd7d9","624":"5509f3ae","646":"9e780288"}[chunkId] + ".chunk.js";
};